export const getVideoEmbedUrl = (url) => {
  if (!url) return '';

  try {
    const parsed = new URL(url);
    const hostname = parsed.hostname.replace('www.', '');
    const pathname = parsed.pathname || '';

    // MP4 directo
    if (pathname.toLowerCase().endsWith('.mp4')) {
      return url;
    }

    // -------------------
    // YOUTUBE
    // -------------------
    if (hostname === 'youtube.com' || hostname === 'm.youtube.com') {
      const videoId = parsed.searchParams.get('v');

      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}`;
      }

      // Si ya es embed
      if (pathname.startsWith('/embed/')) {
        return url;
      }
    }

    if (hostname === 'youtu.be') {
      const videoId = pathname.split('/').filter(Boolean)[0];
      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}`;
      }
    }

    // -------------------
    // VIMEO
    // -------------------
    if (hostname === 'vimeo.com' || hostname === 'player.vimeo.com') {
      const videoId = pathname.split('/').filter(Boolean).pop();
      if (videoId) {
        return `https://player.vimeo.com/video/${videoId}`;
      }
    }

    // -------------------
    // TIKTOK
    // -------------------
    if (
      hostname === 'tiktok.com' ||
      hostname === 'm.tiktok.com' ||
      hostname === 'vm.tiktok.com'
    ) {
      const match = pathname.match(/\/(video|v)\/(\d+)/);
      if (match?.[2]) {
        return `https://www.tiktok.com/embed/v2/${match[2]}`;
      }
    }

  } catch (error) {
    return url;
  }

  return url;
};
